import { RootLogger, Logger } from 'loglevel';
import { axiosClientFactory } from './utils/axiosClientFactory';
import { AxiosSdkInstance, Config, GetToken, GetTraceId, Options } from './types';
import { AdonisClient } from '@utex/adonis-client';

export interface ApiClients {
  rest?: AxiosSdkInstance;
  securedRest?: AxiosSdkInstance;
  stream?: AdonisClient;
}

export class BaseApiClient {
  protected config: Config;
  protected logger: Logger;
  protected schema: any;

  protected clients: ApiClients = {};

  constructor(
    options: Config | Options,
    logger: Logger | undefined,
    schema: any,
    getTokens?: GetToken,
    getTraceId?: GetTraceId
  ) {
    this.schema = schema;
    // @ts-ignore
    if (!options.logger) {
      this.config = options as Config;
      this.logger = logger!;

      if (this.config.rest) {
        this.clients.rest = axiosClientFactory(this.config.rest, undefined, getTraceId);
        this.clients.securedRest = axiosClientFactory(this.config.rest, getTokens, getTraceId);
      }

      if (this.config.stream) {
        this.clients.stream = new AdonisClient(
          this.config.stream,
          this.logger as RootLogger,
          getTokens
        );
      }
    } else {
      const objectOptions = options as Options;
      this.config = objectOptions.config;
      this.logger = objectOptions.logger;

      if (this.config.rest) {
        this.clients.rest = axiosClientFactory(
          this.config.rest,
          undefined,
          objectOptions.getTraceId
        );
        this.clients.securedRest = axiosClientFactory(
          this.config.rest,
          objectOptions.getTokens,
          objectOptions.getTraceId,
          objectOptions.removeTokens
        );
      }

      if (this.config.stream) {
        this.clients.stream = new AdonisClient(
          this.config.stream,
          this.logger as RootLogger,
          objectOptions.getTokens
        );
      }
    }
  }

  onLogout() {
    if (this.clients.stream) {
      this.clients.stream.logout();
    }
  }

  destroy() {
    this.onLogout();
  }
}
